import React from 'react';

function Loading() {
  return (
    <div>
      <div className='quiz-loading'></div>
    </div>
  );
}

export default Loading;
